/* global ga */
import ConfigsManager from './configs';
import { rtcVersion } from './version';
import { LogFactory } from './logging';
var Logger = LogFactory('Analytics');
var isLocalServer = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
var trackEventFactory = function (appName, trackerName) {
    return function (eventCategory, eventAction, eventLabel) {
        if (eventLabel === void 0) { eventLabel = ''; }
        return ga(trackerName + ".send", 'event', eventCategory, eventAction, eventLabel);
    };
};
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.trackerName = 'rtcjs_tracker';
        this.trackEvent = function () { };
    }
    Analytics.prototype.init = function () {
        if (isLocalServer) {
            Logger.warn('Google Analytics will not be instantiated for local builds');
            return;
        }
        var code = ConfigsManager.analytics;
        if (!code) {
            Logger.warn('Google Analytics will not be instantiated for unknown environment');
            return;
        }
        if (ga && typeof ga !== 'undefined') {
            ga('create', code, 'auto', this.trackerName, { 'sampleRate': 0.1 });
            ga(this.trackerName + ".set", 'appName', ConfigsManager.appName);
            ga(this.trackerName + ".set", 'appVersion', rtcVersion);
            this.trackEvent = trackEventFactory(ConfigsManager.appName, this.trackerName);
            return;
        }
    };
    return Analytics;
}());
export { Analytics };
export default new Analytics();
//# sourceMappingURL=analytics.js.map